import React, {useState, useEffect} from "react";
import question from "../Assets/Images/question.png";

const DailyPrompt = (props) => {
    const prompts = ['What was something new you tried today?','What would you like to become better at?','What did you do today that made you think hard?','How can you use that mistake to do better next time?','What challenge or problem have you worked on today?','How can you make the things that are too easy for you more challenging?','Did you do anything today that was too easy for you?','What did you learn today outside of school?','Is there anything you are struggling with? What new strategies can you try next?','Can you think of something new you tried today? What was it?','Can you think of a mistake you made today? What can you learn from that mistake?','Was there anything that made you feel stuck today? What other ways can you try next time?','What could you have done better today? Who can you ask for feedback?','What was the best thing that happened at school today?','What did you find challenging about school today?','Tell me something that made you laugh today.','If you could choose who would you like to sit by in class? Why?','Who would you NOT want to sit by in class? Why?','Where is the coolest place at the school?','Tell me a weird word that you heard today.','If I called your teacher tonight what would I hear about you?','How did you help somebody today?','How did somebody help you today?','Tell me one thing that you learned today.','When were you the happiest today?','When were you bored today? How did you create value anyway?','Who would you like to play with at recess that you’ve never played with before?','What word did your teacher say most today?','What do you think you could do/learn more of at school?','Who in your class do you think you could be more kind to?','Where do you play the most at recess?','Who is the funniest person in your class? Why is he/she/they so funny?','What was your favorite part of lunch?','If you got to be the teacher tomorrow what would you do?',"What was the best thing that happened at school today? (What was the worst thing that happened at school today?)",
"Tell me something that made you laugh today.",
"If you could choose who would you like to sit by in class? (Who would you NOT want to sit by in class? Why?)",
"Where is the coolest place at the school?",
"Tell me a weird word that you heard today. (Or something weird that someone said.)",
"If I called your teacher tonight what would she tell me about you?",
"How did you help somebody today?",
"How did somebody help you today?",
"Tell me one thing that you learned today.",
"When were you the happiest today?",
"When were you bored today?",
"If an alien spaceship came to your class and beamed up someone who would you want them to take?",
"Who would you like to play with at recess that you’ve never played with before?",
"Tell me something good that happened today.",
"What word did your teacher say most today?",
"What do you think you should do/learn more of at school?",
"What do you think you should do/learn less of at school?",
"Who in your class do you think you could be nicer to?",
"Where do you play the most at recess?",
"Who is the funniest person in your class? Why is he/she/they so funny?",
"What was your favorite part of lunch?",
"If you got to be the teacher tomorrow what would you do?",
"Is there anyone in your class that needs a time out?",
"If you could switch seats with anyone in the class who would you trade with? Why?",
"Tell me about three different times you used your pencil today at school.",'What was the best thing that happened at school today? (What was the worst thing that happened at school today?)',
'Tell me something that made you laugh today.',
'If you could choose who would you like to sit by in class? (Who would you NOT want to sit by in class? Why?)',
'Where is the coolest place at the school?',
'Tell me a weird word that you heard today. (Or something weird that someone said.)',
'If I called your teacher tonight what would she tell me about you?',
'How did you help somebody today?',
'How did somebody help you today?',
'Tell me one thing that you learned today.',
'When were you the happiest today?',
'When were you bored today?',
'If an alien spaceship came to your class and beamed up someone who would you want them to take?',
'Who would you like to play with at recess that you’ve never played with before?',
'Tell me something good that happened today.',
'What word did your teacher say most today?',
'What do you think you should do/learn more of at school?',
'What do you think you should do/learn less of at school?',
'Who in your class do you think you could be nicer to?',
'Where do you play the most at recess?',
'Who is the funniest person in your class? Why is he/she/they so funny?',
'What was your favorite part of lunch?',
'If you got to be the teacher tomorrow what would you do?',
'Is there anyone in your class that needs a time out?',
'If you could switch seats with anyone in the class who would you trade with? Why?',
'Tell me about three different times you used your pencil today at school.',]
    const [prompt,setPrompt] = useState("");
    
    const getWindowSize = () => {
        const { innerWidth, innerHeight } = window;
        return { innerWidth, innerHeight };
    }
    const [windowSize, setWindowSize] = useState(getWindowSize());

    useEffect(() => {
      function handleWindowResize() {
        setWindowSize(getWindowSize());
      }
  
      window.addEventListener("resize", handleWindowResize);
  
      return () => {
        window.removeEventListener("resize", handleWindowResize);
      };
    }, []);

    useEffect(() => {
        document.title = `${props.title} ${props.now}`;
    })

    const getPrompt = () => {
        const num = Math.floor(Math.random() * prompts.length);
        setPrompt(prompts[num]);
    }

    return (
        <div className="daily-prompt-section">
            <h2>Daily Prompt</h2>
            <div className="pic-prompt-wrapper">
                {prompt && windowSize.innerWidth >= 768 ? <img className="pic-prompt" src={question} alt="prompt" /> : null}
                <div className="prompt-wrapper">
                {prompt ? 
                    <p>{prompt}</p>
                : <img className="pic-only" src={question} alt="prompt" />}
                </div>
             </div>
            <button className="btn" onClick={getPrompt}>Get Prompt</button>
        </div>
    )
}

export default DailyPrompt;